import {connect} from "react-redux";
import RegularizationRequestListLogs from "./RegularizationRequestListLogs";
import {bindActionCreators} from "redux";
import { regularizationDetailsForManager, getRegularizationRequestFilter } from "../../service/DarwinAttendance/action";

const mapStateToProps = (state) => ({
    regularizationDetails: state.DarwinAttendanceSync.regularizationDetails,
    regularizationFilter: state.DarwinAttendanceSync.regularizationFilter
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            regularizationDetailsForManager,
            getRegularizationRequestFilter
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(RegularizationRequestListLogs);
